module.exports = __webpack_public_path__ + "static/media/emoji3.73ce81a9.png";